import React from 'react';

import AppRouter from 'router';

const App: React.FC = () => {
  return <AppRouter />;
};

export default App;
